import { ApiService } from './api';
import { ApiResponse, AdminResponse, CreateAdminRequest } from '../types/auth';

export class AdminsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getAllAdmins(): Promise<ApiResponse<AdminResponse[]>> {
    try {
      const response = await this.apiService.get<AdminResponse[]>('/admin/all-admins');
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch admins',
        success: false
      };
    }
  }

  async createAdmin(request: CreateAdminRequest): Promise<ApiResponse<AdminResponse>> {
    try {
      const response = await this.apiService.post<AdminResponse>('/admin/create-admin', request);
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to create admin',
        success: false
      };
    }
  }

  async deleteAdmin(adminId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete<void>(`/admin/${adminId}`);
      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to delete admin',
        success: false
      };
    }
  }
}

export const adminsService = new AdminsService();
